<!-- Open Defect warning panel -->
@if(submittedSummaryItems() && submittedSummaryItems().length > 0)
{
<app-open-defects-warning [titleValue]="'OPEN_DEFECTS_STATUS_DISPLAY'" [titleDesc]="'OPEN_DEFECTS_MESSAGE_DISPLAY'"
    [mainClass]="'common-warning-panel'" [headerClass]="'warning-color'" [descClass]="'dark-color'"
    [iconSrc]="'assets/icon/warning-outline-orange.svg'"></app-open-defects-warning>
}

@for (item of submittedSummaryItems(); track $index) {

<ion-card class="shadow-none ion-no-margin borderMargin ion-margin-top ion-margin-bottom">
    <ion-card-content>
        <ion-row class="d-flex align-items-center">
            <ion-col size="6" class="d-flex flex-column">
                <ion-text class="primary-color reg_num">
                    {{item.reG_NUMBER}}
                </ion-text>
                <ion-text class="primary-color pt-1">
                    {{item.totaL_DEFECTS}} Open Defects
                </ion-text>
            </ion-col>
            <ion-col size="6" class="d-flex justify-content-end">
                <ion-button (click)="onReviewDefects(item)" (keydown.enter)="onReviewDefects(item)"
                    class="btn_secondary">
                    <ion-text [ngClass]="{'font-sm': isMobileApp}">
                        {{'PRE_USE_LABLE27' | translate}}
                    </ion-text>
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-card-content>
</ion-card>

}